// @mui material components
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import colors from "assets/theme/base/colors";

// add useTheme and useMediaQuery
import { Card, CardContent, Typography, Box, Tabs, Tab, Avatar, Pagination } from "@mui/material";

import { useEffect, useState } from "react";
import { getAllContinents } from "services/apiService";
import { allUsers } from "services/apiService";
import { getAllVideosDash } from "services/apiService";
import { getUserStats } from "services/apiService";
import { allUsersByContinent } from "services/apiService";
import Loader from "components/Loader/loader";
import { getAllSubscriptions } from "services/apiService";

function Dashboard() {
  const [tab, setTab] = useState(0);
  const [page, setPage] = useState(1);
  const [continentsData, setContinentsData] = useState([]);
  const [usersCount, setUsersCount] = useState(0);
  const [todaysUsers, setTodaysUsers] = useState(0);
  const [totalVideo, setTotalVideo] = useState(0);
  const [promotionalCount, setPromotionalCount] = useState(0);
  const [nonPromoCount, setNonPromoCount] = useState(0);
  const [time, setTime] = useState(new Date());
  const [userStats, setUserStats] = useState([]);
  const [continentUsers, setContinentUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeCount, setActiveCount] = useState(0);
  const [total, setTotal] = useState("");
  const [purchaseToday, setPurchaseToday] = useState(0);

  const rowsPerPage = 10;
  const { info } = colors;

  const getRelativeTime = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffMs = now - past; // difference in milliseconds

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 5) return "Just now";
    if (seconds < 60) return `${seconds} sec ago`;
    if (minutes < 60) return `${minutes} min ago`;
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    return `${days} day${days > 1 ? "s" : ""} ago`;
  };

  const [timeAgo, setTimeAgo] = useState(getRelativeTime(time));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeAgo(getRelativeTime(time));
    }, 30000);

    return () => clearInterval(interval);
  }, [time]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
    setPage(1);

    const selectedContinent = continentsData[newValue];
    if (selectedContinent) {
      getUserByContinent(selectedContinent.id);
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    (async () => {
      await getContinents();
      await getAllUsers();
      await getAllVideo();
      await getUserStatastics();
      await getAllPurchase();
    })();
  }, []);

  const getAllUsers = async () => {
    try {
      const response = await allUsers();
      setTime(new Date());
      if (response?.success) {

        const usersVerified = response?.data?.users
          .filter((u) => u.isVerified)

        const totalUsers = usersVerified?.length;

        const today = new Date().toISOString().slice(0, 10);
        const usersAddedToday = response?.data?.users?.filter(
          (user) => user.createdAt.slice(0, 10) === today
        ).length;

        setUsersCount(totalUsers);
        setTodaysUsers(usersAddedToday);
      }
    } catch (err) {
      console.error("Fetch users failed:", err);
    }
  };

  const getAllVideo = async () => {
    try {
      const response = await getAllVideosDash();
      if (response?.success) {
        const totalVideoCount = response?.data?.reduce((count, user) => {
          const videos = user.media.filter(item => item.type === "video");
          return count + videos.length;
        }, 0);

        const result = response?.data?.reduce(
          (acc, user) => {
            user.media.forEach(item => {
              if (item.type === "video") {
                if (item.isPromotion) {
                  acc.promotional++;
                } else {
                  acc.nonPromotional++;
                }
              }
            });
            return acc;
          },
          { promotional: 0, nonPromotional: 0 }
        );

        setTotalVideo(totalVideoCount);
        setPromotionalCount(result?.promotional);
        setNonPromoCount(result?.nonPromotional);
      }
    } catch (err) {
      console.error("Fetch users failed:", err);
    }
  };

  const getUserStatastics = async () => {
    try {
      const response = await getUserStats();
      if (response?.success) {
        setUserStats(response.data.usersByContinent || []);
      }
    } catch (err) {
      console.error("Fetch users failed:", err);
    }
  };

  const getContinents = async () => {
    try {
      const response = await getAllContinents();
      if (response?.success) {
        setContinentsData(response?.data);
        if (response?.data?.length > 0) {
          const defaultContinentId = response.data[0].id;
          getUserByContinent(defaultContinentId);
        }
      }
    } catch (err) {
      console.error("Fetch users failed:", err);
    }
  };

  const getUserByContinent = async (continentId) => {
    setLoading(true);
    try {
      const response = await allUsersByContinent(continentId);
      if (response?.success) {
        setContinentUsers(response.data?.users || []);
      }
    } catch (err) {
      console.error("Fetch users failed:", err);
    } finally {
      setLoading(false);
    }
  };

  const getAllPurchase = async () => {
    try {
      const response = await getAllSubscriptions();
      if (response?.success) {
        const activeCount = response?.data?.users?.filter((item) => item?.status === true).length;

        const today = new Date().toISOString().slice(0, 10);
        const purchaseAddedToday = response?.data?.users?.filter(
          (user) => user?.startDate.slice(0, 10) === today
        ).length;

        setActiveCount(activeCount);
        setPurchaseToday(purchaseAddedToday);
        setTotal(response?.data?.totalAmount);
      }
    } catch (err) {
      console.error("Fetch users failed:", err);
    }
  };

  const paginatedData = continentUsers.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="Total Users"
                count={usersCount}
                percentage={{
                  color: "success",
                  amount: todaysUsers,
                  label: "Added today",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                isVideo={true}
                icon="play_circle"
                title="Total Videos"
                count={totalVideo}
                percentage={{
                  color: "success",
                  amount: nonPromoCount,
                  label: "Posted Videos",
                }}
                percentage1={{
                  color: "success",
                  amount: promotionalCount,
                  label: "Promotional Videos",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="paid"
                title="Revenue"
                count={total != "" ? total : 0}
                percentage={{
                  color: "success",
                  amount: "",
                  label: timeAgo,
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="store"
                title="Active Subscriptions"
                count={activeCount}
                percentage={{
                  color: "success",
                  amount: purchaseToday,
                  label: "Purchased today",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>

        <MDBox py={1}>
          <MDBox>
            <Card>
              <CardContent sx={{ padding: 3 }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Users by Continent
                </Typography>
                <Tabs
                  value={tab}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  sx={{
                    "& .MuiTabs-flexContainer": {
                      display: "flex",
                      flexWrap: "nowrap",
                    },
                    "& .MuiTab-root": {
                      minWidth: "120px",
                      flexShrink: 0,
                    },
                    p: 1,
                    mt: 2,
                  }}
                  TabIndicatorProps={{ style: { backgroundColor: info.main, height: 3 } }}
                >
                  {continentsData.map((continent) => {
                    const userCount =
                      userStats.find((stat) => stat.continentId === continent.id)?.userCount || 0;
                    return (
                      <Tab
                        key={continent.name}
                        label={
                          <Box display="flex" flexDirection="column" alignItems="center">
                            <MDBox component="img" src={continent?.imageUrl} width="3rem" />
                            <Typography variant="subtitle2">{continent?.name}</Typography>
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              sx={{ gap: 1 }}
                            >
                              <Typography variant="h6" color={"green"}>
                                {userCount}
                              </Typography>
                              <Typography variant="caption">Users</Typography>
                            </Box>
                          </Box>
                        }
                      />
                    );
                  })}
                </Tabs>

                {/* User List (chat-style like screenshot) */}
                <Box mt={2}>
                  {loading ? (
                    <Loader />
                  ) : paginatedData.length > 0 ? (
                    paginatedData.map((user) => (
                      <Box
                        key={user.id}
                        display="flex"
                        alignItems="center"
                        py={1.5}
                        px={1}
                        sx={{
                          borderBottom: "1px solid",
                          borderColor: "divider",
                        }}
                      >
                        <Avatar
                          src={user.profile}
                          alt={user.name}
                          sx={{ width: 50, height: 50, mr: 2 }}
                        />
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography fontWeight="bold" variant="subtitle2" noWrap>
                            {user.name}
                          </Typography>
                          <Typography variant="subtitle2" color="text.secondary" noWrap>
                            {`${user?.countryCode}${user?.phoneNumber}`}
                          </Typography>
                        </Box>
                      </Box>
                    ))
                  ) : (
                    <Typography mt={2}>No users available</Typography>
                  )}
                </Box>

                {/* Pagination */}
                <Box display="flex" justifyContent="center" mt={2}>
                  <Pagination
                    count={Math.ceil(continentUsers.length / rowsPerPage) || 1}
                    page={page}
                    onChange={handlePageChange}
                    color="info"
                  />
                </Box>
              </CardContent>
            </Card>
          </MDBox>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
